import { from, iif, Observable, of, switchMap } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';

import { requiredHeaders } from '../../../models/required-headers';
import { authenticateResponseSchema } from '../../../schemas/authenticate-response.schema';
import { AuthenticatedUser } from '../../../schemas/authenticated-user.schema';
import { applySchema } from '../../../utils/apply-schema';
import { normalizeCallBehavior } from '../../../utils/normalize-call-behavior';
import { normalizeErrorReporting } from '../../../utils/normalize-error-reporting';
import { authwsEnvironment } from '../authws-environment';

/**
 * Authenticate user via TID
 * @param authCode Authorization code from TID redirect
 * @param redirectUrl Whitelisted Callback URL on Trimble Cloud
 * @param applicationName Trimble Maps Application name from SSO (Optional)
 * @param trimbleApplication Application Name on Trimble Cloud
 * @returns Authenticated User
 */
export function postTidAuthenticate(
  this: unknown,
  authCode: string,
  requestOptions: {
    applicationName?: string;
    redirectUrl: string;
    trimbleApplication: string;
  }
): Observable<AuthenticatedUser>;
/**
 * Authenticate user via TID
 * @param authCode authorization code from TID redirect
 * @param redirectUrl Whitelisted Callback URL on Trimble Cloud
 * @param applicationName Trimble Maps Application name from SSO (Optional)
 * @param trimbleApplication Application Name on Trimble Cloud
 * @param account selected account
 * @returns Authenticated User (Optional)
 */
export function postTidAuthenticate(
  this: unknown,
  authCode: string,
  requestOptions: {
    applicationName?: string;
    redirectUrl: string;
    trimbleApplication: string;
  },
  account?: string
): Observable<AuthenticatedUser>;
export function postTidAuthenticate(
  this: unknown,
  arg1: string,
  arg2: {
    applicationName?: string;
    redirectUrl: string;
    trimbleApplication: string;
  },
  arg3?: string
) {
  const request: Record<string, unknown> = {
    authorizationCode: arg1,
    redirectUrl: arg2.redirectUrl,
    trimbleApplication: arg2.trimbleApplication,
  };

  if (typeof arg2.applicationName === 'string') {
    request['applicationName'] = arg2.applicationName;
  }

  if (typeof arg3 === 'string') {
    request['account'] = arg3;
  }

  return fromFetch(
    new Request(authwsEnvironment.resolve(this).trimbleidAuthenticateUrl, {
      method: 'POST',
      headers: {
        ...requiredHeaders,
      },
      credentials: 'include',
      body: JSON.stringify(request),
    })
  ).pipe(
    switchMap((response: Response) => {
      return response.status === 400
        ? from(response.json() as Promise<Record<string, unknown>>)
        : of(response);
    }),
    switchMap((response) => {
      return iif(
        () => response instanceof Response,
        of(response) as unknown as Observable<Response>,
        of(
          new Response(JSON.stringify(response), {
            status:
              typeof (response as Record<string, unknown>)['accounts'] ===
              'undefined'
                ? 400
                : 200,
          })
        )
      );
    }),
    normalizeCallBehavior(),
    applySchema(authenticateResponseSchema),
    normalizeErrorReporting()
  );
}
